package components.finishingUp

import components.project.isProjectEditable
import it.neckar.commons.kotlin.js.safeGet
import it.neckar.lizergy.model.project.ResolvedProject
import it.neckar.lizergy.model.stumps.FinishingUp.Checklist
import it.neckar.react.common.*
import it.neckar.react.common.form.*
import react.*
import react.dom.*
import services.UiActions

val EditFertigmeldungChecklist: FC<EditFertigmeldungChecklistProps> = fc("EditFertigmeldungChecklist") { props ->
  val project = props::project.safeGet()
  val finishingUp = project.finishingUp
  val editableStatus = project.isProjectEditable()

  val checklist = finishingUp.checklist

  fun saveChecklistChange(updated: Checklist) {
    UiActions.saveFinishingUp(finishingUp.copy(checklist = updated))
  }

  div("my-4") {
    h4("my-3") { +"Checkliste Fertigmeldung" }

    div {
      checkbox(
        value = checklist.zaehlertauschInExcelEingetragen,
        onChange = { saveChecklistChange(checklist.copy(zaehlertauschInExcelEingetragen = it)) },
        fieldName = "zaehlertauschInExcelEingetragen",
        title = "Zählertausch in Abrechnungs-Excel eingetragen",
        editableStatus = editableStatus,
      )
    }
    div {
      checkbox(
        value = checklist.streitbemerkungEingepflegt,
        onChange = { saveChecklistChange(checklist.copy(streitbemerkungEingepflegt = it)) },
        fieldName = "streitbemerkungEingepflegt",
        title = "Streitbemerkung eingepflegt (Installierte Leistung, IBN)",
        editableStatus = editableStatus,
      )
    }
    div {
      checkbox(
        value = checklist.teamsOneDriveDatenHeruntergeladen,
        onChange = { saveChecklistChange(checklist.copy(teamsOneDriveDatenHeruntergeladen = it)) },
        fieldName = "teamsOneDriveDatenHeruntergeladen",
        title = "Teams/One Drive Daten heruntergeladen",
        editableStatus = editableStatus,
      )
    }
    div {
      checkbox(
        value = checklist.bestelllisteAktualisiert,
        onChange = { saveChecklistChange(checklist.copy(bestelllisteAktualisiert = it)) },
        fieldName = "bestelllisteAktualisiert",
        title = "Bestellliste aktualisiert",
        editableStatus = editableStatus,
      )
    }
    div {
      checkbox(
        value = checklist.monitoringKontrolliert,
        onChange = { saveChecklistChange(checklist.copy(monitoringKontrolliert = it)) },
        fieldName = "monitoringKontrolliert",
        title = "Monitoring (Sunny Portal/EnnexOS) kontrolliert",
        editableStatus = editableStatus,
      )
    }
    div {
      checkbox(
        value = checklist.marktstammdatenregistrierungErledigt,
        onChange = { saveChecklistChange(checklist.copy(marktstammdatenregistrierungErledigt = it)) },
        fieldName = "marktstammdatenregistrierungErledigt",
        title = "Marktstammdatenregistrierung erledigt",
        editableStatus = editableStatus,
      )
    }
    div {
      checkbox(
        value = checklist.smaGarantieRegistriert,
        onChange = { saveChecklistChange(checklist.copy(smaGarantieRegistriert = it)) },
        fieldName = "smaGarantieRegistriert",
        title = "SMA 5+5 Garantie für Kunde registriert",
        editableStatus = editableStatus,
      )
    }
    div {
      checkbox(
        value = checklist.fertigmeldungAnNetzbetreiberVersendet,
        onChange = { saveChecklistChange(checklist.copy(fertigmeldungAnNetzbetreiberVersendet = it)) },
        fieldName = "fertigmeldungAnNetzbetreiberVersendet",
        title = "Fertigmeldung an Netzbetreiber versendet",
        editableStatus = editableStatus,
      )
    }
    div {
      checkbox(
        value = checklist.uebergabeplanErstelltUndAbgelegt,
        onChange = { saveChecklistChange(checklist.copy(uebergabeplanErstelltUndAbgelegt = it)) },
        fieldName = "uebergabeplanErstelltUndAbgelegt",
        title = "Ü-Plan erstellt & abgelegt",
        editableStatus = editableStatus,
      )
    }
  }
}

external interface EditFertigmeldungChecklistProps : Props {
  var project: ResolvedProject
}
